import AxiosAPI from '../../../utils/AxiosAPI';

export const ApiLogsFilesDeleteOpe = (fileName) => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/logs/file/delete/${fileName}`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};
export const ApiLogsAllFilesDeleteOpe = () => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/logs/file/delete-all`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const ApiLogsFilesListOpe = () => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath('/api/logs/file')
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export default null;
